import React from "react";
import { connect } from "react-redux";
import { Segment, Header } from "semantic-ui-react";
import { ventasOps } from "../../ducks/ventas";
import NavMenu from "./ventas/NavMenu";
import TablaColegios from "./ventas/TablaColegios";
import capitalize from "lodash/capitalize";

class Ventas extends React.Component {
  state = {
    tipo: null,
    pagina: 0
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    return nextProps.match.params !== prevState.tipo
      ? {
          tipo: nextProps.match.params.opcion,
          pagina: nextProps.match.params.pagina
        }
      : null;
  }

  componentDidMount() {
    const { itemsPorPagina, provinciaActiva } = this.props;
    const { tipo } = this.state;
    this.props.obtenerDatosPaginacion({
      itemsPorPagina,
      tipo,
      provinciaActiva
    });
    this.props.obtenerPagina({ itemsPorPagina, tipo, provinciaActiva });
    this.props.obtenerNombreColegios();
    this.props.obtenerLocalidades();
  }

  componentDidUpdate(prevProps, prevState) {
    const { opcion: prevOpcion, pagina: prevPagina } = prevProps.match.params;
    const { opcion, pagina } = this.props.match.params;

    if (
      prevOpcion !== opcion ||
      prevPagina !== pagina ||
      prevProps.provinciaActiva !== this.props.provinciaActiva ||
      prevProps.colegioBuscado !== this.props.colegioBuscado ||
      prevProps.localidadBuscada !== this.props.localidadBuscada
    ) {
      this.props.resetListaColegios();

      const pag =
        prevProps.provinciaActiva !== this.props.provinciaActiva ||
        prevProps.colegioBuscado !== this.props.colegioBuscado ||
        prevProps.localidadBuscada !== this.props.localidadBuscada
          ? 1
          : pagina;

      const {
        itemsPorPagina,
        provinciaActiva,
        colegioBuscado,
        localidadBuscada
      } = this.props;

      const { tipo } = this.state;

      this.props.obtenerDatosPaginacion({
        itemsPorPagina,
        tipo,
        provinciaActiva,
        idColegio: colegioBuscado,
        localidadBuscada
      });

      this.props.obtenerPagina({
        itemsPorPagina,
        tipo,
        pagina: pag,
        provinciaActiva,
        idColegio: colegioBuscado,
        localidadBuscada
      });
    }
  }

  componentWillUnmount() {
    this.props.resetProvinciaActiva();
    this.props.resetColegioBuscado();
    this.props.resetLocalidadBuscada();
    this.props.resetListaColegios();
  }

  handleChangePage = activePage =>
    this.props.history.push(
      `/ventas/${this.props.match.params.opcion}/${activePage}`
    );

  handleButtonClick = ({ idColegio, opcion }) => {
    this.props.seleccionarColegio(idColegio);

    switch (opcion) {
      case "tarea":
        this.props.history.push(`/ventas/nuevo/tarea/${idColegio}`);
        break;
      case "cita":
        this.props.history.push(`/ventas/nuevo/cita/${idColegio}`);
        break;
      case "contacto":
        this.props.history.push(`/ventas/nuevo/contacto/${idColegio}`);
        break;
      default:
        break;
    }
  };

  handleChangeEstado = ({ estado, idColegio }) =>
    this.props.cambiarEstadoVenta({ estado, idColegio });

  handleProvinciaActiva = name => {
    this.props.setProvinciaActiva({ name });
    this.props.resetColegioBuscado();
    this.props.resetLocalidadBuscada();
  };

  handleColegioBuscado = ({ idColegio }) => {
    this.props.resetProvinciaActiva();
    this.props.setColegioBuscado({ idColegio });
    this.props.resetLocalidadBuscada();
  };

  handleLocalidad = localidad_provincia => {
    this.props.resetProvinciaActiva();
    this.props.resetColegioBuscado();
    this.props.setLocalidadBuscada({ localidad_provincia });
  };

  render() {
    const {
      itemsTotales,
      match: {
        params: { opcion }
      }
    } = this.props;

    return (
      <Segment>
        <Header
          as="h3"
          content={`Ventas ${capitalize(opcion)}: ${itemsTotales}`}
        />
        <NavMenu
          handleChangePage={this.handleChangePage}
          paginasTotales={this.props.paginasTotales}
          activePage={this.props.paginaActual}
          handleProvinciaActiva={this.handleProvinciaActiva}
          nombreColegios={this.props.nombreColegios}
          handleColegioBuscado={this.handleColegioBuscado}
          localidades={this.props.localidades}
          handleLocalidad={this.handleLocalidad}
        />
        <TablaColegios
          datos={this.props.listaColegios}
          handleButtonClick={this.handleButtonClick}
          handleChangeEstado={this.handleChangeEstado}
        />
      </Segment>
    );
  }
}

const mapStateToProps = ({ ventas }, props) => ({
  listaColegios: ventas.listaColegios,
  itemsPorPagina: ventas.itemsPorPagina,
  paginaActual: ventas.paginaActual,
  itemsInicialesPorPagina: ventas.itemsInicialesPorPagina,
  paginasTotales: ventas.paginasTotales,
  itemsTotales: ventas.itemsTotales,
  inicializacion: ventas.inicializacion,
  provinciaActiva: ventas.provinciaActiva,
  nombreColegios: ventas.nombreColegios,
  colegioBuscado: ventas.colegioBuscado,
  localidades: ventas.localidades,
  localidadBuscada: ventas.localidadBuscada
});

const mapDispatchToProps = {
  resetListaColegios: ventasOps.resetListaColegios,
  obtenerDatosPaginacion: ventasOps.obtenerDatosPaginacion,
  obtenerPagina: ventasOps.obtenerPagina,
  seleccionarColegio: ventasOps.seleccionarColegio,
  detachPagina: ventasOps.detachPagina,
  detachPaginaPorTipo: ventasOps.detachPaginaPorTipo,
  detachPaginacion: ventasOps.detachPaginacion,
  setProvinciaActiva: ventasOps.setProvinciaActiva,
  resetProvinciaActiva: ventasOps.resetProvinciaActiva,
  obtenerNombreColegios: ventasOps.obtenerNombreColegios,
  obtenerLocalidades: ventasOps.obtenerLocalidades,
  setColegioBuscado: ventasOps.setColegioBuscado,
  resetColegioBuscado: ventasOps.resetColegioBuscado,
  cambiarEstadoVenta: ventasOps.cambiarEstadoVenta,
  setLocalidadBuscada: ventasOps.setLocalidadBuscada,
  resetLocalidadBuscada: ventasOps.resetLocalidadBuscada
};

export default connect(mapStateToProps, mapDispatchToProps)(Ventas);



// WEBPACK FOOTER //
// ./src/pages/ventas/Ventas.jsx